module.exports = "module.exports = __webpack_public_path__ + \"assets/data/next-show-hr.json\";";